import isValidEmail from 'lib/validEmail';

/**
 * Check if a field is populated
 * @param {string} message
 */
export function required(message) {
  return (/** @type {unknown} */ value) => {
    if (!value) {
      return message;
    }
    return undefined;
  };
}

/**
 * Check if a field is a valid email
 * @param {string} value
 */
export function validEmail(value) {
  if (!isValidEmail(value)) {
    return 'Please enter a valid email address.';
  }
  return undefined;
}
